export default __webpack_public_path__ + "static/media/bg-engage.36e45e20.svg";